export default __webpack_public_path__ + "static/media/block7icon2.7b60460e.svg";